
export const searchReducer = (state = {}, action) => {
    switch(action.type){
        case "search/set": {
            const payload = action.payload;
            if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
                return {
                    ...payload,
                    search: typeof payload.search === 'string' ? payload.search : '',
                };
            }
            return {};
        }
        default:
            return state
    }
}